var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clickable pt-1",attrs:{"title":"Click here to add a task"},on:{"click":_vm.addTask}},[_c('BaseIcon',{attrs:{"properties":{
			height: 'h-7',
			width: 'w-7',
			strokeWidth: '1.5',
			classes: [
				'stroke-pastel-yellow-400',
				'drop-shadow-md'
			],
		},"dArray":['M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z']}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }